module.exports = __webpack_public_path__ + "img/firewallSetting.38be10f.svg";